import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
    gap: 8px;
    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
    }
`;

export const Text = styled.div`
    white-space: nowrap;
    align-items: center;
    ${FONTS.MediumXS};
`;

